<template>
  <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
    >
      <v-card>

        <v-toolbar dark>
          <v-card-title>{{ `${edit ? 'Update' : 'Add'} dewey decimal class` }}</v-card-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-spacer></v-spacer>
            <v-btn icon  @click="reset">
              <i class="fas fa-times"></i>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div class="row">
            <div class="col-6">
              <v-text-field type="text" outlined dense label="Title" v-model="dewey_class.title"></v-text-field>
              <span class="text-danger" v-if="$v.dewey_class.title.$error">Title is required</span>
            </div>
            <div class="col-6">
              <v-select label="Parent" :items="dewey_class_parents" item-value="id" item-text="title" outlined dense v-if="!dewey_class.is_parent" v-model="dewey_class.parent_id">
              </v-select>
              <span class="text-danger" v-if="!dewey_class.is_parent && $v.dewey_class.parent_id.$error">This information is required</span>
            </div>
            <div class="col-12">
              <v-textarea cols="30" rows="10" outlined dense v-model="dewey_class.description"
                          label="Description"></v-textarea>
            </div>
            <div class="col-4  mt-5" v-if="!dewey_class.parent_id">
              Is parent
              <v-switch
                  v-model="dewey_class.is_parent"
                  color="primary"
                  :label="dewey_class.is_parent?'Yes':'No'"
              >
              </v-switch>
            </div>
            <div class="col-4 form-group mt-5">
              Status
              <v-switch
                  v-model="dewey_class.is_active"
                  :label="dewey_class.is_active?'Active':'Inactive'"
                  color="primary"
              >
              </v-switch>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-right">
            <v-btn
                class="btn btn-standard cancel-btn"
                depressed
                @click="reset"
            >Cancel
            </v-btn>

            <v-btn v-if="checkIsAccessible('library-dewey_decimal_class', 'create')"
                   class="text-white ml-2 btn btn-primary"
                   depressed
                   @click="createOrUpdate"
            >Save
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import DeweyDecimalClassService from "@/core/services/library/dewey-decimal-class/DeweyDecimalClassService";
import {required} from "vuelidate/lib/validators";

const classService = new DeweyDecimalClassService();
export default {
  name: "CreateAndUpdate",
  validations() {
    return {
      dewey_class: this.rules
    }
  },
  data() {
    return {
      dewey_class: {
        title: null,
        parent_id: null,
        is_parent: 0,
        is_active: 1,
        isBusy: null,
        description: null
      },
      dialog: false,
      edit: false,
      dewey_class_parents: [],
    }
  }, computed: {
    rules() {
      let rule = {
        title: {required}
      }
      if (!this.dewey_class.is_parent) {
        rule['parent_id'] = {required}
      }
      return rule;
    }
  }, mounted() {
    this.getParents()
  },
  methods: {
    getParents() {
      classService.getAllParent().then(response => {
        this.dewey_class_parents = response.data.parents;
      })
    },
    createOrUpdate() {
      this.$v.$touch()
      if (this.$v.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 3000)
      } else {
        this.dewey_class.is_parent = this.dewey_class.parent_id?0:1;
        if (this.edit) {
          this.update();
        } else {
          this.save();
        }
      }
    }, getDeweyDecimalClass(id) {
      classService.show(id).then(response => {
        this.dewey_class = response.data.decimalClass;
        this.edit = true
      })
    }, showModal(id = null) {
      if (id) {
        this.edit = true
        this.getDeweyDecimalClass(id)
      }
      this.getParents()
      this.dialog =true;
    },
    hideModal() {
      this.dialog=false;
    },
    toggleModal() {
      this.dialog =! this.dialog;
    }, update() {
      this.isBusy = true
      classService.update(this.dewey_class.id, this.dewey_class).then(response => {
        this.$snotify.success("Updated successfully")
        this.reset()
      })
    },
    save() {
      this.isBusy = true
      classService.store(this.dewey_class).then(response => {
        this.$snotify.success("Created successfully")
        this.reset()
      })
    }, reset() {
      this.dewey_class = {
        title: null,
        parent_id: null,
        is_parent: 0,
        is_active: 1,
        description: null
      }
      this.edit = false
      this.isBusy = false
      this.$v.$reset();
      this.$emit("close_dialog")
    }
  }
}
</script>

<style scoped>

</style>